// src/molecules/ThemeSwitcher.tsx
/* eslint-disable react/prop-types */

import { IconButton } from '@chakra-ui/react';
import { FaMoon, FaSun } from 'react-icons/fa';

interface ThemeSwitcherProps {
  darkMode?: boolean; // Indicates if dark mode is active
  onToggle: () => void; // Function to toggle the theme
}

export const ThemeSwitcher: React.FC<ThemeSwitcherProps> = ({ darkMode, onToggle }) => {
  return (
    <IconButton
      ml="4"
      icon={darkMode ? <FaMoon /> : <FaSun />}
      aria-label="Toggle Theme"
      variant="ghost"
      onClick={onToggle}
    />
  );
};
